import React, { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import NavigationBar from "component/navigationBar/NavigationBar";
import NavigationBarItemBack from "component/navigationBar/NavigationBarItemBack";
import NavigationBarItem from "component/navigationBar/NavigationBarItem";
import NavigationBarTabs from "component/navigationBar/NavigationBarTabs";
import t from "module/translations";

interface Props {
  listPath: string;
  overviewPath: string;
  assigneesPath: string;
}

const TrainingCustomDetailsNavigation: React.FC<Props> = ({
  listPath,
  overviewPath,
  assigneesPath,
}) => {
  const matchedOverview = Boolean(
    useRouteMatch({
      path: overviewPath,
      exact: true,
    })
  );
  const matchedAssignees = Boolean(
    useRouteMatch({
      path: assigneesPath,
      exact: true,
    })
  );

  const matchedList = false;

  const tabMap: boolean[] = useMemo(
    () => [matchedList, matchedOverview, matchedAssignees],
    [matchedAssignees, matchedList, matchedOverview]
  );

  return (
    <NavigationBar>
      <NavigationBarTabs {...{ tabMap }}>
        <NavigationBarItemBack
          {...{
            path: listPath,
            key: listPath,
          }}
        />
        <NavigationBarItem
          {...{
            key: overviewPath,
            path: overviewPath,
            title: t.competencyManagement.trainingCustom.overviewTitleText,
          }}
        />
        <NavigationBarItem
          {...{
            key: assigneesPath,
            path: assigneesPath,
            title: t.competencyManagement.trainingCustom.assigneesTitleText,
          }}
        />
      </NavigationBarTabs>
    </NavigationBar>
  );
};

export default React.memo(TrainingCustomDetailsNavigation);
